import React, { Component } from "react"
import { connect } from "react-redux"
import { requestResource } from "home/api_request"
import { DailyMissionEngagementAndPerformanceTablePresentation } from "home/components/daily_mission"
import TableWrapper from "home/components/table_wrapper"

class DailyMissionEngagementAndPerformanceTableContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      tableData: {
        data: null,
        columns: null
      }
    }
  }

  componentDidMount () {
    this.updateData()
  }

  componentDidUpdate (prevProps) {
    if (JSON.stringify(prevProps.filters) != JSON.stringify(this.props.filters)) {
      this.updateData()
    }
  }

  updateData () {
    const { filters } = this.props

    requestResource("daily_mission/engagement_and_performance", filters, response =>
      this.setState({ tableData: response.data })
    )
  }

  render () {
    return (
      <TableWrapper
        presenter={DailyMissionEngagementAndPerformanceTablePresentation}
        tableData={this.state.tableData}
        resource="daily_mission/engagement_and_performance"
        filters={this.props.filters}
      />
    )
  }
}

const mapStateToProps = state => {
  return {
    filters: {
      userId: state.filters.userId,
      schoolYear: state.filters.schoolYear,
      schoolClass: state.filters.schoolClass,
      schoolId: state.filters.schoolId,
      dateFilterStartDate: state.filters.dateFilterStartDate,
      dateFilterEndDate: state.filters.dateFilterEndDate
    }
  }
}

export default connect(mapStateToProps)(DailyMissionEngagementAndPerformanceTableContainer)
